var base = require('kiosk/users');

Vue.component('spark-kiosk-users', {
    mixins: [base],
    data(){
        return {
            headers: [{
                value: 'photo_url', sortable: false
            },{
                text: 'Name', value: 'name', align: 'left'
            },{
                text: 'Email', value: 'email', align: 'left'
            },{
                value: 'view', sortable: false
            }]
        };
    },
	methods: {
		/**
         * Show the search results.
         */
        showSearch() {
            this.showingUserProfile = false;

            // Vue.nextTick(function () {
            //     $('#kiosk-users-search').focus();
            // });
        },
	}
});
